export const lang = {
  home: '首页',
  htmltitle: 'GMIC 在线 Pro',
  mainstage: '全球领袖峰会',
  stage2: '全球营销增长大会',
  speakers: '嘉宾',
  agenda: '日程',
  search: '发现',
  status1: '即将开始',
  status2: '已结束',
  status3: '正在直播',
  zddw: '指导单位',
  hzhb: '合作伙伴',
  pphzhb: '品牌合作伙伴',
  nrhzhb: '内容合作伙伴',
  fgw: '北京市发改委',
  zgc: '中关村科学城',
  djdzk: '大家都在看',
  jbgnl: '视频连麦',
  dh: '对话',
  dlzc: '登录/注册',
  zcxx: '注册信息',
  true: '（请提供真实信息）',
  hy: '您所属的行业：',
  three: '（* 最多选择三项）',
  three2: '您最多可选择三项行业',
  tg: '跳过',
  ljzc: '立即注册',
  tj: '提交',
  one: '请至少选择一项您的行业',
  error: '请求失败，请稍后再试',
  notfull: '注册信息不完整',
  name: '姓名',
  company: '公司',
  title: '职位',
  tel: '手机号码',
  email: '邮箱',
  ts: '提示',
  qr: '确认',
  unstart: '直播暂未开始',
  end: '直播已结束',
  kbsj: '开播时间',
  djhzhb: '顶级合作伙伴',
  mt: '合作媒体'
}



// WEBPACK FOOTER //
// ./src/common/lang/cn.js